var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.563a.75.75 0 0 1 1.188-.61 8.2 8.2 0 0 0 4.062 1.514V8.203A6 6 0 0 1 15.047 3H12.75v11.625a3.376 3.376 0 1 1-5.25-2.807V9.225c-2.175.788-3.75 2.94-3.75 5.4a5.625 5.625 0 1 0 11.25 0zm1.5 5.062a7.125 7.125 0 1 1-14.25 0c0-3.493 2.519-6.517 5.868-7.113A.75.75 0 0 1 9 8.25v4.002a.75.75 0 0 1-.429.678 1.875 1.875 0 1 0 2.679 1.695V2.25A.75.75 0 0 1 12 1.5h3.75a.75.75 0 0 1 .75.75 4.5 4.5 0 0 0 4.5 4.5.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-.749.75 9.7 9.7 0 0 1-4.501-1.097z"
  })));
};
export default SvgTiktok;